
import { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';

import styles from './TimeAndDateSelctionPop.module.css';
import pageStylePops from './pageStylePops.module.css';

import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';

import { UserContext } from '../Contexts/User_Context';
import DateTimePick from '../ForAllComponents/DateTimePick';
import { TheOrderContext } from '../Contexts/TheOrder_Context';

const TimeAndDateSelctionPop = (props) => {

    const navigate = useNavigate();
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [user, setUser] = useContext(UserContext);
    

    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : styles);
    const [pageDetails, setPageDetails] = useState();
    const [erMsg, setErMsg] = useState("");
    const [digits, setDigits] = useState("");
    const [selectdedDateTime, setSelectdedDateTime] = useState("");

    const [thePopUp, setThePopUp] = useState();


    useEffect(() => {
    }, [mobiOrNot]);

    useEffect(() => {
        if (selectdedDateTime && selectdedDateTime !== "") {
            setErMsg(selectdedDateTime)
        }
    }, [selectdedDateTime])

    useEffect(() => {

    }, [])

    

    const goCheckTheCode = () => {
        setErMsg(selectdedDateTime);
        props.continueFunction(selectdedDateTime);
    }

    return (
        <>
            <div className={`${pageStylePops.topPlace} regularPoint`}>
                <div className={`${styles.topTextArea} fullRow spaceMargeButtomBig`}>
                    <p className={`${pageStylePops.headBig} fullRow`}>בחירת מועד הזמנה</p>
                    <span className={`${pageStylePops.secondHead} inColorgoldLine`}>לפני שנמשיך, יש לבחור מועד לקבלת ההזמנה</span>
                </div>

                <DateTimePick
                    drpArrCss={"drpArrowWhite"}
                    wrpaStyl={"DtPickwrpaStyl"}
                    lbl="ל"
                    Css="inputsStyle pointing"
                    selectedDate={(val) => setSelectdedDateTime(val)}

                />
            </div>

            <div className={`${pageStylePops.mainWrap}`}>

                <div className={"fullRow errorLine bold centerText margTopBig"}>
                    <span>{parse(erMsg)}</span>
                </div>
                {selectdedDateTime && selectdedDateTime !== "" &&
                    <div className={pageStylePops.contWrap}>
                        <div className={pageStylePops.btnGo}>
                            <button className={`${pageStylePops.contactGo} pointing`} value="המשך"
                                onClick={() => goCheckTheCode()} >המשך</button>
                        </div>
                    </div>
                }

            </div>
            {thePopUp}
        </>

    );
}

export default TimeAndDateSelctionPop;


// <div className={styles.checksOfTimeToGet}>
//                 <div className={`${styles.checksOTChekcs} fullRow`}>
//                     <Checkbox
//                         // value={soundCheckd}
//                         checked={true}
//                         onChange={() => updateChkSelection()}
//                         checkedIcon={<CheckCircleOutline />}
//                         icon={<PanoramaFishEye />}
//                         sx={{}}
//                     />
//                     <span className={`${pageStylePops.secondHead} inColorgoldLine noPadding`}>נא להכין ולשלוח.</span>
//                 </div>
//                 <div className={`${styles.checksOTChekcs} fullRow`}>
//                     <Checkbox
//                         // value={soundCheckd}
//                         checked={true}
//                         onChange={() => updateChkSelection()}
//                         checkedIcon={<CheckCircleOutline />}
//                         icon={<PanoramaFishEye />}
//                         sx={{}}
//                     />
//                     <span className={`${pageStylePops.secondHead} inColorgoldLine`}>בחירת מועד אחר.</span>
//                 </div>
//             </div> s